/* eslint-disable */
'use strict';

/*
  Helper that selects the appropriate PropTypes to use for React.
  Node v8 and above gets the separate `prop-types` dependency.
  Node v7 and below gets the built in PropTypes from React.
*/

module.exports = require('react').PropTypes || require('prop-types');